/**
* @ngdoc directive
* @name Numbers Only
*
* @deprecated
*
* @element input
*
* @description
* allow only numbers in text input.
*
* @example
  <div ng-init='contact="12345"'>
  <input type="text" class="form-control" numbers-only maxlength="9" ng-model='contact' />
  </div>
*/

app.directive('numbersOnly', function(){
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, modelCtrl) {
      var rule = attrs.replaceRegex || "[^0-9]";
      var pattern = new RegExp(rule, 'g');
      modelCtrl.$parsers.push(function (inputValue){
        // this next if is necessary for when using ng-required on your input.
        // In such cases, when a letter is typed first, this parser will be called
        // again, and the 2nd time, the value will be undefined
        if (inputValue === undefined) return '';
        var transformedInput = inputValue.replace(pattern, '');
        if (transformedInput!=inputValue) {
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }
        return transformedInput;
      });
    }
  };
});



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/onlyNumbersDirective.js